import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.less'

SidebarCount.propTypes = {
  count: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.number,
    PropTypes.string,
  ]),
}

SidebarCount.defaultProps = {
  count: undefined,
}

export default function SidebarCount({ count }) {
  return <span className={styles.SidebarItem_count}>{count}</span>
}
